/**
 * Base configuration properties.
 *
 * This file should be version-controlled and contain the configuration
 * properties.
 *
 * @class config-base
 * @module Config
 * @static
 */
declare var globalConfig;

export class CoreConfig implements Config {
    constructor() {
        Object.keys(globalConfig)
            .forEach((key)=>this[key] = globalConfig[key]);
    }

    /** Is debug-mode enabled.*/
    debug;

    uiVersion;
    appVersion;
    eakVersion;

    /**
     * Base url under which ui service endpoints are expected to be mapped.
     */
    apiUrl;
    baseUrl;
    securityUrl;
    casUrl;


    /**
     * Default language.
     *
     * @property language
     * @type String
     */
    language = 'et';
}

export let config = new CoreConfig();


// WEBPACK FOOTER //
// ./src/main/ui/core/application/Config.ts